/* tslint:disable */
/* eslint-disable */
import { OrganizationalUnit } from '../enums/organizational-unit';

export { OrganizationalUnit }